<script setup lang="ts">
import dayjs from 'dayjs';

import terms from '@/assets/pdf/terms.pdf';
import { appContact } from '@/constants';
</script>

<template>
  <footer
    class="w-full relative overflow-hidden bg-blue-800 text-white mt-auto font-ubuntu font-light"
  >
    <div
      class="flex-col-center gap-4 relative z-[1] max-w-screen-xl mx-auto p-9 text-center md:flex-row md:flex-wrap md:gap-0"
    >
      <RouterLink
        :to="{ name: 'home' }"
        class="flex-col-center gap-3 md:basis-2/6"
        :aria-label="$t('navigation.home.title')"
      >
        <Icon icon-name="BrandLogo" class="w-10 h-10" />
        <Icon icon-name="BrandTitle" class="w-40 h-8" />
      </RouterLink>

      <div class="flex-col-center gap-2 md:basis-2/6 md:gap-3">
        <a
          rel="noreferrer"
          :href="`mailto:${appContact.email}`"
          target="_blank"
          :aria-label="$t('shared.contactByEmail')"
        >
          {{ appContact.email }}
        </a>
        <a
          rel="noreferrer"
          :href="`sms:${appContact.phone}`"
          target="_blank"
          :aria-label="$t('shared.contactBySms')"
        >
          {{ appContact.phone }}
        </a>
        <a
          rel="noreferrer"
          :href="`https://www.google.com/maps/search/${encodeURIComponent(appContact.address)}`"
          target="_blank"
          :aria-label="$t('shared.openMap')"
        >
          {{ appContact.address }}
        </a>
      </div>

      <div class="flex-col-center md:basis-2/6 md:gap-3">
        <a
          rel="noreferrer"
          :href="appContact.linkedinLink"
          class="flex-center-center gap-2"
          target="_blank"
          :aria-label="$t('shared.openLinkedin')"
        >
          <Icon icon-name="LinkedinLogo" class="w-8 h-8" />
          <p>LinkedIn</p>
        </a>
        <a
          rel="noreferrer"
          :href="appContact.instagramLink"
          class="flex-center-center gap-2"
          target="_blank"
          :aria-label="$t('shared.openInstagram')"
        >
          <Icon icon-name="InstagramLogo" class="w-8 h-8" />
          <p>Instagram</p>
        </a>
      </div>

      <p class="mt-4 md:mt-8 md:basis-full">
        ©{{ dayjs().year() }} - BROKN | {{ $t('footer.allRightReserved') }}
      </p>
      <p>
        <a :href="terms" :download="$t('footer.legalTerms')" :aria-label="$t('footer.legalTerms')">
          {{ $t('footer.legalTerms') }}
        </a>
      </p>
    </div>

    <Icon
      icon-name="BrandLogo"
      class="absolute z-0 text-blue h-48 w-48 rotate-90 opacity-30 -right-16 -bottom-6 md:scale-[1.5] md:-right-12 md:bottom-2"
    />
  </footer>
</template>
